import {
  bartenderAvailability,
  calculateBartender
} from 'shared/models/api';

export const BARTENDER_RATE = 'BARTENDER_RATE';
export const BARTENDER_AVAILABILITY = 'BARTENDER_AVAILABILITY';
export const BARTENDER_AVAILABILITY_LOADING = 'BARTENDER_AVAILABILITY_LOADING';
export const BARTENDER_TOTAL_LOADING = 'BARTENDER_TOTAL_LOADING';
export const BARTENDER_TOTAL_ERROR = 'BARTENDER_ERROR';
export const BARTENDER_TOTAL = 'BARTENDER_TOTAL';
export const BARTENDER_PROMO_ADD = 'BARTENDER_PROMO_ADD';
export const BARTENDER_PROMO_REMOVE = 'BARTENDER_PROMO_REMOVE';
export const BARTENDER_SELECT_CARD = 'BARTENDER_SELECT_CARD';
export const BARTENDER_ORDER_ID = 'BARTENDER_ORDER_ID';

const initState = {
  rate: null,
  available: null,
  availabilityLoading: false,
  lineItems: [],
  booking: {}
}

export default function reducer(state = initState, action = {}) {
  switch (action.type) {
    case BARTENDER_RATE:
      return { ...state, rate: action.rate }
    case BARTENDER_AVAILABILITY:
      return { ...state, available: action.available, availabilityLoading: false }
    case BARTENDER_AVAILABILITY_LOADING:
      return { ...state, availabilityLoading: true }
    case BARTENDER_TOTAL_LOADING:
      return { ...state, totalLoading: true }
    case BARTENDER_TOTAL_ERROR:
      return { ...state, totalLoading: false }
    case BARTENDER_TOTAL:
      return { ...state, totalLoading: false, lineItems: action.lineItems, booking: action.booking }
    case BARTENDER_PROMO_ADD:
      return {...state, promo: action.promo};
    case BARTENDER_PROMO_REMOVE:
      return {...state, promo: null};
    case BARTENDER_ORDER_ID:
      return {...state, orderId: action.orderId };
    case BARTENDER_SELECT_CARD:
      return {...state, cardId: action.cardId};
    default:
      return state
  }
}

export function getAvailability(address) {
  return dispatch => {
    dispatch({ type: BARTENDER_AVAILABILITY_LOADING });
    return bartenderAvailability(address).then((res) => {
      dispatch({ type: BARTENDER_AVAILABILITY, available: !!res.available });
    });
  }
}

export function calculateTotal(params) {
  return dispatch => {
    dispatch({ type: BARTENDER_TOTAL_LOADING });
    return calculateBartender(params).then((res) => {
      dispatch({ type: BARTENDER_TOTAL, lineItems: res.display, booking: res.booking });
    }).catch((err) => {
      dispatch({ type: BARTENDER_TOTAL_ERROR });
    });
  }
}

export function selectPromo(promo) {
  return dispatch => dispatch({type: BARTENDER_PROMO_ADD, promo});
}

export function removePromo() {
  return dispatch => dispatch({type: BARTENDER_PROMO_REMOVE});
}

export function setOrderId() {
  return (dispatch, getState) => {
    const user = getState().login.user;
    const orderId = [user.objectId, new Date().getTime()].join('-');
    dispatch({ type: BARTENDER_ORDER_ID, orderId });
  }
}

export function selectCard(id) {
  return dispatch => dispatch({type: BARTENDER_SELECT_CARD, cardId: id});
}



// WEBPACK FOOTER //
// ./shared/components/bartender/actions.js